//bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
// bao migrate - module not found: import Bao from "services/bao-template-engine";
ko.virtualElements.allowedBindings.foreachSelection = true;
ko.bindingHandlers.foreachSelection = {
    checkSelection: function (item, valueAccessor) {
        var pk = valueAccessor().pk;
        if (pk != null && valueAccessor().selection().length > 0) {
            var i = 0;
            ko.utils.arrayFirst(valueAccessor().selection(), function (selectedItem) {
                if (ko.unwrap(item[pk]) == ko.unwrap(selectedItem[pk])) {
                    item.selected(true);
                    valueAccessor().selection()[i] = item;
                    return true;
                }
                i++;
                return false;
            });
        }
    },
    setMultiSelectionRek: function (selected, id, valueAccessor, items) {
        ko.utils.arrayForEach(items(), function (item: any) {
            if (ko.unwrap(item[ko.unwrap(valueAccessor().pk)]) == id) {
                item.selected(selected);
                if (selected == false) {
                    valueAccessor().selection.remove(item);
                }
            }
            if (item.__Children != null && item.__Children().length > 0) {
                ko.bindingHandlers.foreachSelection.setMultiSelectionRek(selected, id, valueAccessor, item.__Children);
            }
        });
    },
    rowClicked: function (event, dataItem, valueAccessor) {
        if (typeof valueAccessor().BeforeSelectionChanges === "function") {
            var res = valueAccessor().BeforeSelectionChanges(dataItem);
            if (typeof res === "object" && typeof res.done === "function") {
                res.done(function (allowedByDeferred) {
                    if (allowedByDeferred == true) {
                        ko.bindingHandlers.foreachSelection.rowClickChangesSelection(event, dataItem, valueAccessor);
                    }
                });
            }
            else {
                if (res == true) {
                    ko.bindingHandlers.foreachSelection.rowClickChangesSelection(event, dataItem, valueAccessor);
                }
            }
        }
        else {
            ko.bindingHandlers.foreachSelection.rowClickChangesSelection(event, dataItem, valueAccessor);
        }
    },
    rowClickChangesSelection: function (event, dataItem, valueAccessor) {
        var mode = ko.unwrap(valueAccessor().mode || "single");
        dataItem.selected(!dataItem.selected());
        if (mode == "multi") {
            if (dataItem.selected() == true) {
                valueAccessor().selection.push(dataItem);
            }
            else { }
            var selectionItems;
            if (valueAccessor().data != undefined) {
                selectionItems = valueAccessor().data;
            }
            else if (valueAccessor().rootModels != undefined) {
                selectionItems = valueAccessor().rootModels;
            }
            ko.bindingHandlers.foreachSelection.setMultiSelectionRek(dataItem.selected(), ko.unwrap(dataItem[ko.unwrap(valueAccessor().pk)]), valueAccessor, selectionItems);
        }
        else if (mode == "single") {
            var isSelected = dataItem.selected();
            ko.bindingHandlers.foreachSelection.resetSelection(false, valueAccessor);
            dataItem.selected(isSelected);
            if (dataItem.selected() == true) {
                valueAccessor().selection([dataItem]);
            }
            else {
                valueAccessor().selection([]);
            }
        }
    },
    itemRendered: function (elementsArray, dataItem, valueAccessor) {
        ko.utils.arrayForEach(elementsArray, function (ele: any) {
            if (ele.nodeType == 1) {
                $(ele).click(function (event) {
                    ko.bindingHandlers.foreachSelection.rowClicked(event, dataItem, valueAccessor);
                });
            }
        });
        var baseAfterRender = valueAccessor().afterRender;
        if (baseAfterRender != null) {
            baseAfterRender(elementsArray, dataItem);
        }
    },
    resetSelection: function (updateSelection, valueAccessor, itemsToReset) {
        var selection = valueAccessor().selection;
        var items;
        if (itemsToReset != null) {
            items = itemsToReset;
        }
        else if (valueAccessor().data != undefined) {
            items = valueAccessor().data;
        }
        else if (valueAccessor().rootModels != undefined) {
            items = valueAccessor().rootModels;
        }
        ko.utils.arrayForEach(items(), function (item: any) {
            item.selected(false);
            if (item.__Children != null && item.__Children().length > 0) {
                ko.bindingHandlers.foreachSelection.resetSelection(updateSelection, valueAccessor, item.__Children);
            }
        });
        if (updateSelection == true) {
            selection([]);
        }
    },
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        if (ko.unwrap(valueAccessor().setTemplate) != undefined) {
            if (element.nodeType == 8) {
                var $templateContainer = $("<div>");
                $templateContainer.append($(ko.virtualElements.childNodes(element)).clone() as any);
                Bao.Templates[ko.unwrap(valueAccessor().setTemplate)] = $templateContainer.html();
            }
        }
        return ko.bindingHandlers.foreach.init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var checkSelection = function (item) {
            ko.bindingHandlers.foreachSelection.checkSelection(item, valueAccessor);
        };
        var itemRenderedEvent = function (elementsArray, dataItem) {
            ko.bindingHandlers.foreachSelection.itemRendered(elementsArray, dataItem, valueAccessor);
        };
        var newValueAccesor = function () {
            return {
                data: valueAccessor().data,
                afterRender: itemRenderedEvent
            };
        };
        ko.utils.arrayForEach(valueAccessor().data(), function (item: any) {
            if (item.selected == undefined) {
                item.selected = ko.observable(false);
            }
            checkSelection(item);
        });
        ko.bindingHandlers.foreach.update(element, newValueAccesor, allBindingsAccessor, viewModel, bindingContext);
    }
};
ko.virtualElements.allowedBindings.templateSelection = true;
ko.bindingHandlers.templateSelection = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        return ko.bindingHandlers.template.init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var checkSelection = function (item) {
            ko.bindingHandlers.foreachSelection.checkSelection(item, valueAccessor);
        };
        var itemRenderedEvent = function (elementsArray, dataItem) {
            ko.bindingHandlers.foreachSelection.itemRendered(elementsArray, dataItem, valueAccessor);
        };
        var newValueAccesor = function () {
            return {
                name: valueAccessor().name,
                foreach: valueAccessor().foreach,
                afterRender: itemRenderedEvent
            };
        };
        ko.utils.arrayForEach(valueAccessor().foreach(), function (item: any) {
            if (item.selected == undefined) {
                item.selected = ko.observable(false);
            }
            checkSelection(item);
        });
        ko.bindingHandlers.template.update(element, newValueAccesor, allBindingsAccessor, viewModel, bindingContext);
    }
};